import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Modal, Tabs, Tab, FooterButton } from 'Core/components';
import LocationsAddEditForm from './locationmasters-add-edit-form';
import CustomPropTypes from 'Core/prop-types';
import { addLocation, editLocation } from './store/slice';
import { AppModal } from '../components/app-modals';
import { showToast } from 'Core/redux/toast/slice';
import { all_routes } from '../../router/all_routes';

const LocationsAddEdit = ({ showModal, modalData, onCloseModal }) => {
  console.log('LocationsAddEdit -> modalData', modalData);

  const locationsData = modalData;
  const [formData, setFormData] = useState(locationsData || null);
  const [partsData, setPartsData] = useState(locationsData?.parts || []);
  const [pickTicketsData, setPickTicketsData] = useState(locationsData?.locationsPickTickets || []);
  const [filesData, setFilesData] = useState(locationsData?.shippingDocuments || []);

  const dispatch = useDispatch();
  const isEditMode = Boolean(locationsData?.id);

  const onChangesLocationsForm = data => {
    setFormData(data);
  };

  const onChangesParts = data => {
    setPartsData(data);
  };

  const onChangesFiles = data => {
    setFilesData(data);
  };

  const onChangesPickTickets = data => {
    setPickTicketsData(data);
  };

  const handleClose = () => {
    onCloseModal();
  };

  const body = () => {
    return (
      <div className="row">
        <LocationsAddEditForm data={formData} onChanges={onChangesLocationsForm} />
      </div>
    );
  };

  const valid = () => {
    if (!formData ||
      !formData?.name ||
      !formData?.description 
    ) {
      dispatch(
        showToast({
          message: 'Please fill all required fields',
          type: 'danger',
        }),
      );
      return false;
    }
    return true;
  };

  const footer = () => {
    const onSave = () => {
      if (valid()) {
        const payload = {
          ...formData,
          userId: localStorage.getItem('UserId')
        };
        if (isEditMode) {
          dispatch(editLocation(payload));
        } else {
          dispatch(addLocation(payload));
        }
      }
    };

    return (
      <div className="row">
        <div className="col-12 col-lg-8"></div>
        <div className="col-12 col-lg-4">
          <FooterButton
            cancelText="Cancel"
            saveText="Save Location"
            onSave={onSave}
            onCancel={handleClose}
          />
        </div>
      </div>
    );
  };

  return (
    <Modal
      id="locations-modal"
      show={showModal}
      size="xl"
      title={isEditMode ? 'Edit Locations' : 'Add Locations'}
      body={body}
      footer={footer}
      handleClose={handleClose}
    />
  );
};

LocationsAddEdit.propTypes = {
  showModal: PropTypes.bool,
  modalData: PropTypes.shape(CustomPropTypes.Locations),
  onCloseModal: PropTypes.func,
};

export default AppModal(LocationsAddEdit);

